import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Mui
import { Box, Typography } from '@mui/material';
// Icons
import { ScaleOutlined as ScaleOutlinedIcon } from '@mui/icons-material';

const PayloadTooLarge:FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Box
        sx={{
          width: 128,
          height: 128,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: '50%',
          bgcolor: 'white',
          mx: 'auto',
          mb: 4
        }}
      ><ScaleOutlinedIcon color="disabled" fontSize="large" /></Box>
      <Typography sx={{ mb: 4 }} variant="h5">{t('notifications.requests.payloadTooLarge.title')}</Typography>
      <Typography sx={{ mb: 4 }} variant="body1">{t('notifications.requests.payloadTooLarge.content')}</Typography>
    </Fragment>
  )
}

export default PayloadTooLarge;
